import IGlobalState from '@/interfaces/IGlobalState';
import { de } from 'date-fns/locale';
import {
  Marker, Map, LayerGroup, LatLng,
} from 'leaflet';

const GlobalState: IGlobalState = {
  showMobileMenu: false,
  currentRoute: {
    path: '',
    hash: '',
    query: {},
    params: {},
    fullPath: '',
    matched: [],
  },
  drawerActive: false,
  infoDrawerActive: false,
  position: {
    lat: 50.29693,
    lng: 18.95566,
  },
  zoomFactor: 13,
  links: [],
  articles: [],
  parkings: {
    type: '',
    features: [],
  },
  parkingZones: {
    type: '',
    features: [],
  },
  parkingMeters: {
    type: '',
    features: [],
  },
  parkingBoards: {
    type: '',
    features: [],
  },
  parkingSpots: {
    type: '',
    features: [],
  },
  parkingGroups: {
    type: '',
    features: [],
  },
  events: {
    type: '',
    features: [],
  },
  weatherStations: {
    type: '',
    features: [],
  },
  bikeStations: {
    type: '',
    features: [],
  },
  vmsBoards: {
    type: '',
    features: [],
  },
  radarBoards: {
    type: '',
    features: [],
  },
  cameras: {
    type: '',
    features: [],
  },
  traffic: {
    type: '',
    features: [],
  },
  trafficPoints: {
    type: '',
    features: [],
  },
  poiLayers: {
    layers: [],
  },
  poiPoints: {
    type: '',
    features: [],
  },
  trackStartPoints: {
    type: '',
    features: [],
  },
  trackEndPoints: {
    type: '',
    features: [],
  },
  trackLines: [],
  currentWeather: {
    tempAir: 0,
    tempSurf: 0,
    dewPoint: 0,
    heatIndex: 0,
    humidex: 0,
    humidity: 0,
    pressure: 0,
    freezingPoint: 0,
    iceThickness: 0,
    visibility: 0,
    airCO: 0,
    airCO2: 0,
    airNO: 0,
    airNO2: 0,
    airSO2: 0,
    'airPM2.5': 0,
    airPM10: 0,
    airHC: 0,
    noise: 0,
    windSpeed: 0,
    windDeg: 0,
    windGust: 0,
    surfState: '',
    surfMoisture: '',
    salt: 0,
    precipitationOnMinute: 0,
  },
  openWeather: {},
  userPositionMarker: Marker.prototype,
  modes: {
    selectLocation: true,
    showOverlay: false,
  },
  leafletMapInstance: Map.prototype,
  leafletLayers: {
    parkingLayer: LayerGroup.prototype,
    parkingZones: LayerGroup.prototype,
    parkingZonesMarkers: LayerGroup.prototype,
    parkingMeters: LayerGroup.prototype,
    parkingSpots: LayerGroup.prototype,
    parkingGroups: LayerGroup.prototype,
    parkingBoards: LayerGroup.prototype,
    events: LayerGroup.prototype,
    weatherStations: LayerGroup.prototype,
    bikeStations: LayerGroup.prototype,
    vmsBoards: LayerGroup.prototype,
    radarBoards: LayerGroup.prototype,
    cctvFixedCameras: LayerGroup.prototype,
    cctvPtzCameras: LayerGroup.prototype,
    trafficLayer: LayerGroup.prototype,
    trafficPointsLayer: LayerGroup.prototype,
    poiPointsLayer: LayerGroup.prototype,
    trackStartPointsLayer: LayerGroup.prototype,
    trackEndPointsLayer: LayerGroup.prototype,
    trackLinesLayer: LayerGroup.prototype,
  },
  tracks: {
    isSelectedStartPoint: false,
    selectedStartPointId: 0,
    startPointCords: [],
  },
  modal: {
    data: {
      title: '',
      content: '',
      navigationPoint: undefined,
      icon: '',
      lastUpdate: (new Date()).toJSON(),
    },
    display: false,
  },
  otherModals: {
    eventListModal: {
      display: false,
    },
    openWeatherModal: {
      display: false,
    },
    infoModal: {
      display: false,
      data: {
        name: '',
        description: '',
      },
    },
  },
  contrast: false,
  fontSize: 2,
  currentLang: 0,
  navActiveTab: null,
  translations: {},
  requestsToApi: {
    lastUpdateParkings: 0,
    lastUpdateParkingSpots: 0,
    lastUpdateParkingGroups: 0,
    lastUpdateParkingZones: 0,
    lastUpdateParkingMeters: 0,
    lastUpdateParkingBoards: 0,
    lastUpdateTraffic: 0,
    lastUpdateTrafficPoints: 0,
    lastUpdateVmsBoards: 0,
    lastUpdateRadarBoards: 0,
    lastUpdateCameras: 0,
    lastUpdatePoiLayers: 0,
    lastUpdatePoiPoints: 0,
    lastUpdateEvents: 0,
    lastUpdateEventsCategories: 0,
    lastUpdateWeatherStations: 0,
    lastUpdateBikeStations: 0,
    lastUpdateOpenWeather: 0,
  },
  secondsToCheckLastUpdate: 60,
  selectedParkingCode: '',
  selectedTrafficLineCode: null,
  //for new API
  settings: {
    map: {
      // added one value for example others are added dynamic from api
      // showVMS: true,
    },
    mapPoiLayers: {},
    mapEventLayers: {},
    staticParams: {},
  },
  segmentsConfig: {
    param: '',
    no_data_color: '',
    default_color: '',
    values: {},
  },
  eventCategories:[],
};

export default GlobalState;
